const ClipboardIcon = ({ className = '' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M42.6368 15.3518H29.3807C27.3227 15.3518 25.5976 13.7175 25.5371 11.6293C25.5068 11.5687 25.5068 11.5385 25.5068 11.4779V9.84362C25.5068 7.72509 27.2622 6 29.3807 6H42.6368C44.7553 6 46.4804 7.72509 46.4804 9.84362V11.4779C46.4804 11.5385 46.4804 11.599 46.4502 11.6595C46.3896 13.7175 44.6948 15.3518 42.6368 15.3518Z"
        fill="#FF9060"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.0347 12.5659C50.0886 12.1911 50.4445 11.9199 50.8077 12.0272C56.137 13.6012 60 18.5412 60 24.3705V51.3063C60 58.3882 54.2497 64.1688 47.1375 64.1688H24.8625C17.7503 64.1688 12 58.3882 12 51.3063V24.3705C12 18.5427 15.8609 13.6038 21.1613 12.0285C21.5245 11.9205 21.8809 12.1917 21.9355 12.5668C22.4621 16.1864 25.624 18.9834 29.372 18.9834H42.628C46.376 18.9834 49.5117 16.186 50.0347 12.5659ZM34.5473 48.4614L46.5624 36.4463C47.4401 35.5686 47.4401 34.1159 46.5624 33.2382C45.6848 32.3605 44.2321 32.3605 43.3544 33.2382L32.9433 43.6493L28.6456 39.382C27.7679 38.5043 26.3455 38.5043 25.4376 39.382C24.5599 40.2596 24.5599 41.7124 25.4376 42.59L31.3393 48.4614C31.763 48.8851 32.338 49.1272 32.9433 49.1272C33.5486 49.1272 34.1236 48.8851 34.5473 48.4614Z"
        fill="#FF9060"
      />
    </svg>
  )
}

export default ClipboardIcon
